import { z } from 'zod';
import { NO_LETTER_MESSAGE, checkNameRules, type NameProblem } from './name-rules.js';

// ─── Organization name ──────────────────────────────────────────────
// Shared by the tenants API and the New organization dialog.

export const ORG_NAME_MIN_LENGTH = 2;
/** The tenants API limit every existing organization was created under. */
export const ORG_NAME_MAX_LENGTH = 255;

export type OrgNameProblem = NameProblem;

export function checkOrgName(name: string): OrgNameProblem | null {
  return checkNameRules(name, { min: ORG_NAME_MIN_LENGTH, max: ORG_NAME_MAX_LENGTH });
}

/** Default English messages — used server-side where there is no i18n layer. */
export const ORG_NAME_PROBLEM_MESSAGES: Record<OrgNameProblem, string> = {
  required: 'Organization name is required',
  tooShort: `Organization name must be at least ${ORG_NAME_MIN_LENGTH} characters`,
  tooLong: `Organization name must be ${ORG_NAME_MAX_LENGTH} characters or fewer`,
  noLetter: NO_LETTER_MESSAGE,
  markup: 'Organization name cannot contain < or >',
};

/** Trims and enforces the organization-name rules above. */
export const OrgNameSchema = z
  .string()
  .trim()
  .superRefine((name, ctx) => {
    const problem = checkOrgName(name);
    if (problem) {
      ctx.addIssue({ code: z.ZodIssueCode.custom, message: ORG_NAME_PROBLEM_MESSAGES[problem] });
    }
  });
